import React, { useState, useEffect } from 'react';
const $ = require('jquery');
import * as AuthService from '../../services/auth';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { ContentHeader } from '@components';
import TableMyItem from './report/TableMyItem';
import TableCostItem from './report/TableCostItem';
import ModalItem from './modal/ModalItem';
import ModalRecost from './modal/ModalRecost';
import Modal from 'react-bootstrap/Modal';
import ModalTicket from './modal/ModalTicket';
import ModalQr from './modal/ModalQr';
import { logoutUser } from '@store/reducers/auth';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import TableCar from './report/TableCar';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

export default function Manage() {
  const user = useSelector((state) => state.auth.currentUser);
  const [dropdowns, setDropdowns] = useState<any>({});
  const [dropdownsMaster, setDropdownsMaster] = useState<any>([]);
  const [item, setItem] = useState<any>(null);
  const [data, setData] = useState<any[]>([]);
  const [showMd, setShowMd] = useState(false);
  const [showMd2, setShowMd2] = useState(false);
  const [showMd3, setShowMd3] = useState(false);
  const [car, setCar] = useState<any[]>([]);
  const [costCenter, setCostCenter] = useState<any[]>([]);
  const [page, setPage] = useState(0);
  const [page2, setPage2] = useState(0);
  const [key, setKey] = useState('history');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    downloadWaitMe(null);
    downloadCarMe();
    downloadDropdownWs();
    downloadDropdownWs2();
  }, []);

  const hideModal = () => {
    // $('#exampleModal').modal('hide');
    setShowMd(false);
  };

  const downloadCostCenterWs = async (
    companyid: string,
    costid: string,
    year: string
  ) => {
    try {
      const costcenter = await AuthService.downloadCostCenter(
        companyid,
        costid,
        year
      );
      if (costcenter.error) throw 'timeout';

      if (Object.keys(costcenter).length !== 0) {
        console.log(costcenter);
        setCostCenter(costcenter);
      }
    } catch (error) {
      dispatch(logoutUser());
      window.location.href = '/login';
    }
  };

  const downloadDropdownWs = async () => {
    try {
      const dropdowns = await AuthService.downloadDropdownCar(user.ID_EMP);
      if (dropdowns.error) throw 'timeout';

      if (Object.keys(dropdowns).length !== 0) {
        console.log(dropdowns);
        setDropdowns(dropdowns);
      }
    } catch (error) {
      dispatch(logoutUser());
      // navigate('/login');
      window.location.href = '/login';
    }
  };

  const togglePrintModal = (item: any) => {
    // $('#printModal').modal('toggle');
    setShowMd2(!showMd2);
    setItem(item);
  };

  const toggleQrModal = (item: any) => {
    setShowMd3(!showMd2);
    setItem(item);
  };

  const downloadDropdownWs2 = async () => {
    try {
      const dropdowns = await AuthService.downloadDropdownCar2();
      if (dropdowns.error) throw 'timeout';
      setDropdownsMaster(dropdowns);
    } catch (error) {
      dispatch(logoutUser());
      // navigate('/login');
      window.location.href = '/login';
    }
  };

  const toggleModal = (item: any) => {
    // $('#exampleModal').modal('toggle');
    setShowMd(!showMd);
    setItem(item);
  };

  const onRefresh = async (planid: any) => {
    await downloadWaitMe(planid);
    console.log('MOO-RELOAD TABLE FIN(FROM ME)');
  };

  const setPageHandle = (page: number) => {
    setPage(page);
  };

  const setPageHandle2 = (page: number) => {
    setPage2(page);
  };

  const downloadWaitMe = async (planid: any) => {
    try {
      console.log('MOO-RELOAD TABLE START');
      const data = await AuthService.downloadWaitMe('me');
      console.log(data);
      setData(data.map((e) => ({ ...e, enableShortcut: false })));
      if (planid !== null) {
        setItem(data.filter((e: any) => e.planid === planid)[0]);
      }
    } catch (error: any) {
      dispatch(logoutUser());
      // navigate('/login');
      window.location.href = '/login';
    }
  };

  const updateCarWs = async (input: any) => {
    try {
      const result = await AuthService.updateCarMe(input);
      if (result.error) throw 'ERROR';
      toast.success('ดำเนินการแก้ไขแล้ว');
      await downloadCarMe();
    } catch (error: any) {
      toast.error('การแก้ไขผิดพลาด');
    }
  };

  const insertCarWs = async (input: any, file: File) => {
    try {
      console.log(input);
      const result = await AuthService.insertCarWs(input, file);
      if (result.error) throw 'ERROR';
      toast.success('ดำเนินการเพิ่มรถแล้ว');
      await downloadCarMe();
    } catch (error: any) {
      console.error("แท้จริงแล้วแครชเพราะจุดนี้ครับ ->", error);
      toast.error('การเพิ่มรถผิดพลาด');
    }
  };

  // แก้ไขข้อมูลรถพนักงาน
  const editCarWs = async (input, files) => {
    try {
      // เรียกใช้ Service ที่ทำไว้ในสเต็ปที่ 1
      const result = await AuthService.editCarMe(input, files);

      if (result.result === "SUCCESS") {
        alert('💾 แก้ไขข้อมูลรถส่วนตัว และส่งให้ CR ตรวจสอบใหม่เรียบร้อยแล้วครับ!');
        await downloadCarMe();
      } else {
        alert(result.error || 'เกิดข้อผิดพลาดในการแก้ไขข้อมูล');
      }
    } catch (error) {
      console.error(error);
      alert('เกิดข้อผิดพลาดในการเชื่อมต่อระบบ');
    }
  };

  const downloadCarMe = async () => {
    try {
      const cars = await AuthService.downloadCarMe();
      console.log('รถพนักงาน:', cars);
      setCar(cars);
    } catch (error: any) { }
  };

  const hasRejectedCar = car && car.some(item => item.VehicleStatus === 'F');

  return (
    <div>
      <Modal
        show={showMd}
        className={'modal-fullscreen'}
        onHide={() => setShowMd(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>รายละเอียด</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {item && item.system === 'travel' ? (
            <ModalItem
              id={item ? item.planid : 0}
              key={`k-${item ? item.planid : 0}`}
              onRefresh={onRefresh}
              onHide={hideModal}
              item={item}
              mode={'read'}
              dropdowns={dropdowns}
            ></ModalItem>
          ) : item && item.system === 'recost' ? (
            <ModalRecost
              id={item ? item.planid : 0}
              key={`r-${item ? item.planid : 0}`}
              onRefresh={onRefresh}
              onHide={hideModal}
              item={item}
              mode={'read'}
              dropdowns={dropdowns}
            ></ModalRecost>
          ) : (
            <></>
          )}
        </Modal.Body>
      </Modal>
      <Modal
        show={showMd2}
        className={'modal-fullscreen'}
        onHide={() => setShowMd2(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>พิมพ์ใบงาน</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalTicket
            id={item ? item.planid : 0}
            key={`k-${item ? item.planid : 0}`}
            onRefresh={onRefresh}
            onHide={hideModal}
            item={item}
            mode={'read'}
            dropdowns={dropdowns}
          ></ModalTicket>
        </Modal.Body>
      </Modal>
      <Modal
        show={showMd3}
        className={'modal-fullscreen'}
        onHide={() => setShowMd3(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>แสดงรหัสคิวอาร์</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalQr
            id={item ? item.planid : 0}
            key={`k-${item ? item.planid : 0}`}
            onHide={hideModal}
            item={item}
          ></ModalQr>
        </Modal.Body>
      </Modal>
      <ContentHeader title="Me" />{' '}
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="mb-3"
              >
                <Tab eventKey="history" title="ประวัติ">
                  <TableMyItem
                    show={true}
                    onPrintToggle={togglePrintModal}
                    onQrToggle={toggleQrModal}
                    onToggle={toggleModal}
                    items={data}
                    onPageChange={setPageHandle}
                    page={page}
                  />
                </Tab>
                <Tab 
                  eventKey="car" 
                  title={
                    hasRejectedCar ? (
                      <>จัดการรถ <span style={{color: '#dc3545'}}>●</span></>
                    ) : (
                      "จัดการรถ"
                    )
                  }
                >
                  <TableCar
                    cars={car}
                    updateCarWs={updateCarWs}
                    onCreate={insertCarWs}
                    onEdit={editCarWs}
                    dropdownsMaster={dropdownsMaster}
                  ></TableCar>
                </Tab>
                {/* <Tab eventKey="costcenter" title="กลุ่มต้นทุน">
                  <TableCostItem
                    show={true}
                    items={costCenter}
                    onPageChange={setPageHandle2}
                    page={page2}
                  ></TableCostItem>
                </Tab> */}
              </Tabs>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
